import * as React from 'react';

import { PK } from 'common/types';
import { useMappedValues } from 'common/hooks';
import { RelationSelect, CollapsibleSection } from 'common/components';
import { RelationOption } from 'common/components/RelationSelect';
import { toastMessages } from 'common/toastMessages';
import { useMinisPuzzleUpdate, usePuzzlesList } from 'modules/puzzles/queries';
import { useToast } from 'modules/toast';

type Props = {
  pk?: PK;
  selectedPuzzlePk: PK | undefined;
  isReflection?: boolean;
};

const PuzzlePicker = ({ pk, selectedPuzzlePk, isReflection }: Props) => {
  const { mutate, isSuccess, isLoading, isError } = useMinisPuzzleUpdate();
  const { toast } = useToast();
  const puzzlesList = usePuzzlesList();
  const saveStatus = { isSuccess, isLoading, isError };

  const options = useMappedValues(puzzlesList.data, ({ name, pk }) => ({
    label: name,
    value: pk,
  }));

  const defaults = useMappedValues(
    puzzlesList.data?.filter((val) => val.pk === selectedPuzzlePk),
    ({ pk, name }) => ({
      label: name,
      value: pk,
    }),
  );

  const handleSave = (values: RelationOption[]) => {
    if (values[0]?.value && isReflection) {
      toast(toastMessages.ERROR.REFLECTION_AND_PUZZLE_MINI, 'error');
      return;
    }

    if (pk) {
      const payload = {
        pk: pk,
        puzzle_pk: values[0]?.value ?? null,
      };
      mutate(payload);
    }
  };

  return (
    <>
      <CollapsibleSection title="Puzzle" saveStatus={saveStatus} disabled={!pk}>
        <RelationSelect
          onSave={handleSave}
          options={options}
          defaultValues={defaults}
          isMulti={false}
        />
      </CollapsibleSection>
    </>
  );
};

export default PuzzlePicker;
